const _ = {
  state: {
    userInfo: null,
    lineList: [],
    collectPage: 1
  },
  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
    },
    SET_LINE_LIST: (state, data) => {
      state.lineList = data
    },
    SET_COLLECT_PAGE: (state, data) => {
      state.collectPage = data
    }
  },
  actions: {
    // 收藏
    Collect(_, data) {
      return mm
        .http({
          url: '/api/collect/createPost',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    // 收藏详情
    CollectDetail({ commit, rootState }, params) {
      const collect = rootState.list.find((item) => item.key === 'collect')
      const list = collect.list[0].list
      const index = list.findIndex((item) => item._id === parseInt(params.id))
      if (index === -1) return Promise.reject()

      return mm
        .http({
          url: '/api/collect/info',
          method: 'get',
          params: { id: params.id, name: params.name }
        })
        .then(({ data }) => {
          list[index].list = data?.info?.content
            ? [
                typeof data.info.content === 'string'
                  ? JSON.parse(data.info.content)
                  : data.info.content
              ]
            : []

          // 去除id
          const removeId = (list) => {
            list.forEach((item) => {
              item._id = item.id
              delete item.id
              if (item.list) removeId(item.list)
            })
          }
          removeId(list[index].list)
          commit('UPDATE_LIST', rootState.list)
          return data
        })
    },
    // 取消收藏
    CancelCollect(_, data) {
      return mm
        .http({
          url: '/ksh/collect/delete',
          method: 'post',
          data
        })
        .then(({ data }) => {
          return data
        })
    },
    // 收藏列表
    GetCollectList({ commit, rootState }, params = { more: false }) {
      return mm
        .http({
          url: '/api/collect/list',
          method: 'get',
          params: { page_size: 5, page: params.more ? rootState.user.collectPage + 1 : 1 }
        })
        .then(({ data }) => {
          const collect = rootState.list.find((item) => item.key === 'collect')
          const newList = data.list.data.map((item) => {
            return {
              _id: item.id,
              ...item
            }
          })
          if (params.more) {
            collect.list[0].list = [...collect.list[0].list, ...newList]
            commit('SET_COLLECT_PAGE', rootState.user.collectPage + 1)
          } else {
            collect.list[0].list = newList
            commit('SET_COLLECT_PAGE', 1)
          }
          commit('UPDATE_LIST', rootState.list)

          // 未知类型，只能先获取详情
          newList.forEach((item) => {
            mm.dispatch('CollectDetail', item)
          })
          return data
        })
    },
    // 辅助线列表
    GetLineList({ commit }, params = { page: 1, page_size: 20 }) {
      return mm
        .http({
          url: '/api/AuxiliaryLine/list',
          method: 'get',
          params
        })
        .then(({ data }) => {
          commit('SET_LINE_LIST', data.list)
          return data
        })
    },
    // 创建辅助线
    CreateLine({ commit, state }, data) {
      return mm
        .http({
          url: '/api/AuxiliaryLine/createPost',
          method: 'post',
          data
        })
        .then(({ data }) => {
          commit('SET_LINE_LIST', [...state.lineList, data])
          return data
        })
    },
    // 删除辅助线
    DeleteLine({ commit, state }, data) {
      return mm
        .http({
          url: '/api/AuxiliaryLine/delete',
          method: 'post',
          data
        })
        .then(({ data }) => {
          commit(
            'SET_LINE_LIST',
            state.lineList.filter((item) => item.id !== data.id)
          )
          return data
        })
    },
    // 编辑辅助线状态
    EditLineStatus({ commit, state }, data) {
      return mm
        .http({
          url: '/api/AuxiliaryLine/editStatus',
          method: 'post',
          data
        })
        .then(({ data }) => {
          commit(
            'SET_LINE_LIST',
            state.lineList.map((item) => {
              if (item.id === data.id) {
                return { ...item, status: data.status }
              }
              return item
            })
          )
          return data
        })
    }
  }
}

export default _
